import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

import { Assignment } from '@dc-shared-web/hooks/api/assignment/types'

type CreateAssignmentParams = {
  checklist_data_uuid: string
  user_uuid: string
  crunch_uuid: string
  section_ref_id?: string
}

const createAssignment = async (
  apiClient: AxiosInstance,
  params: CreateAssignmentParams
): Promise<Assignment> => {
  const { data } = await apiClient.post<Assignment>('/api/assignments', params)

  return data
}

export const useCreateAssignment = () => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation(
    (mutationParams: CreateAssignmentParams) =>
      createAssignment(apiClient, mutationParams),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          'assignments',
          variables.checklist_data_uuid,
          variables.crunch_uuid,
        ])
      },
    }
  )
}
